import * as React from 'react';
import { classes } from './offering-days.st.css';
import {
  CatalogOfferingInjectedProps,
  withOfferingContext,
} from '../../../catalog-offering-context';

class OfferingDays extends React.Component<CatalogOfferingInjectedProps> {
  render() {
    const { offeringViewModel } = this.props;
    const daysModel = offeringViewModel.days;
    return daysModel ? (
      <div
        tabIndex={0}
        data-hook="tile-days"
        className={`${classes.root} ${offeringViewModel.alignmentStyle}`}
      >
        {daysModel}
      </div>
    ) : null;
  }
}

export default withOfferingContext()(OfferingDays);
